import React from "react";
import AvatarContato from "../AvatarContato";

import { CardHeader } from "@material-ui/core";

import { i18n } from "../../translate/i18n";

const TicketInfo = ({ contact, ticket, onClick }) => {
	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer" }}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={<AvatarContato contact={contact} alt="contact_image" />}
			title={`${contact.name} #${ticket.id}`}
			subheader={
				// Grupo não tem atendente nem etapa (não tem lead): mostra só a conexão.
				ticket.isGroup
					? ticket.whatsapp && `${i18n.t("messagesList.header.connection")} ${ticket.whatsapp.name}`
					: ticket.whatsapp && ticket.user && ticket.queue &&
					`${i18n.t("messagesList.header.connection")} ${ticket.whatsapp.name} | ${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name} | Etapa: ${ticket.queue.name}`
			}
		/>
	);
};

export default TicketInfo;
